import React, { lazy, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../utils/Context";

//material UI
import { Grid, Typography } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";

//imagens
import QuizImage from "../../images/quiz-image.svg";
import Truebutton from "../../images/true-button.svg";
import Falsebutton from "../../images/false-button.svg";

//componentes
const GenderHeader = lazy(() => import("../../components/Header"));

export default function GenderHomeScreen() {
  const navigate = useNavigate();
  const { rules } = useContext(Context);

  useEffect(() => {
    if (rules === 1) navigate("/question");
  }, [rules, navigate]);

  const handleClick = (e) => {
    navigate("/genderonext");
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        minHeight: "100vh",
      }}
    >
      <Grid item xs></Grid>
      <Grid
        item
        xs={10}
        sx={{
          marginBottom: {
            xs: "20%",
            sm: "5%",
            md: "5%",
            lg: "0",
            xl: "0",
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <GenderHeader></GenderHeader>
          </Grid>
          <Grid
            item
            xs={12}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            textAlign={"center"}
            sx={{
              height: {
                xs: "23vh",
                sm: "40vh",
                md: "50vh",
                lg: "35vh",
                xl: "35vh",
              },
            }}
          >
            <img
              src={QuizImage}
              width={"auto"}
              height={"100%"}
              alt="Imagem exemplificativa de acordo com a questão"
            ></img>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              margin: "1vw",
              padding: "1rem",
              borderRadius: "1rem",
              background: "rgba(38, 50, 56, 0.3)",
            }}
          >
            <Typography
              variant="h6"
              color={"#000000"}
              paddingLeft={"0.3em"}
              letterSpacing={0}
              fontWeight={700}
              fontFamily={"Inter, Helvetica, sans-serif"}
            >
              Aqui aparecerá a pergunta?
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              margin: "0 1vw",
              padding: "1rem",
              borderRadius: "1rem",
              background: "rgba(38, 50, 56, 0.3)",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign={"center"}>
                <img src={Truebutton} alt="botão de verdadeiro" />
              </Grid>
              <Grid item xs={12} textAlign={"center"}>
                <img src={Falsebutton} alt="botão de falso" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <ArrowForwardOutlinedIcon
              sx={{
                width: {
                  xs: "10vw",
                  sm: "10vw",
                  md: "7vw",
                  lg: "4vw",
                  xl: "4vw",
                },
                height: "auto",
                animation: "shake 3s infinite",
              }}
              onClick={handleClick}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs></Grid>
    </Grid>
  );
}
